import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { TicketGroupInputValidationSchema } from '../event-page/create';
import { TICKET_GROUP_TRIGGER_ID_DESCRIPTION, TicketGroupEventIdInputSchema } from './params';

export const CreateTicketGroupParamsValidationSchema = z.object({
  pageId: ObjectIdStringValidationSchema,
});

export const CreateTicketGroupRequestValidationSchema = TicketGroupInputValidationSchema.omit({
  key: true,
  ticketTypes: true,
  triggerTicketGroupId: true,
})
  .extend({
    triggerTicketGroupId: ObjectIdStringValidationSchema.nullish(),
  })
  .openapi('TicketGroupControllerInput');

export const CreateTicketGroupInputValidationSchema = z.object({
  pageId: TicketGroupEventIdInputSchema,
  ...CreateTicketGroupRequestValidationSchema.shape,
  triggerTicketGroupId: ObjectIdStringValidationSchema.nullish().meta({
    description: TICKET_GROUP_TRIGGER_ID_DESCRIPTION,
  }),
});

export type CreateTicketGroupInput = z.infer<typeof CreateTicketGroupInputValidationSchema>;
